// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1d4cu","inputWrap":"Table_inputWrap__3wLGW","col":"Table_col__m27mk","bmiTooltip":"Table_bmiTooltip__Xe8hC"};